import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import Notification from '../components/Notification/Notification';
import baseServerUrl from '../services/apiServer';

// Import German translations
import deAccount from './locales/de/account.json';
import deAuth from './locales/de/auth.json';
import deBrowse from './locales/de/browse.json';
import deCommon from './locales/de/common.json';
import deDashboard from './locales/de/dashboard.json';
import deOrganization from './locales/de/organization.json';
import dePayments from './locales/de/payments.json';
import deReferral from './locales/de/referral.json';
import deValidation from './locales/de/validation.json';
import enAccount from './locales/en/account.json';
import enAuth from './locales/en/auth.json';
import enBrowse from './locales/en/browse.json';
import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enOrganization from './locales/en/organization.json';
import enPayments from './locales/en/payments.json';
import enReferral from './locales/en/referral.json';
import enValidation from './locales/en/validation.json';
import esAccount from './locales/es/account.json';
import esAuth from './locales/es/auth.json';
import esBrowse from './locales/es/browse.json';
import esCommon from './locales/es/common.json';
import esDashboard from './locales/es/dashboard.json';
import esOrganization from './locales/es/organization.json';
import esPayments from './locales/es/payments.json';
import esReferral from './locales/es/referral.json';
import esValidation from './locales/es/validation.json';
import frAccount from './locales/fr/account.json';
import frAuth from './locales/fr/auth.json';
import frBrowse from './locales/fr/browse.json';
import frCommon from './locales/fr/common.json';
import frDashboard from './locales/fr/dashboard.json';
import frOrganization from './locales/fr/organization.json';
import frPayments from './locales/fr/payments.json';
import frReferral from './locales/fr/referral.json';
import frValidation from './locales/fr/validation.json';
// Import Canadian French translations
import frCAAccount from './locales/fr-CA/account.json';
import frCAAuth from './locales/fr-CA/auth.json';
import frCABrowse from './locales/fr-CA/browse.json';
import frCACommon from './locales/fr-CA/common.json';
import frCADashboard from './locales/fr-CA/dashboard.json';
import frCAOrganization from './locales/fr-CA/organization.json';
import frCAPayments from './locales/fr-CA/payments.json';
import frCAReferral from './locales/fr-CA/referral.json';
import frCAValidation from './locales/fr-CA/validation.json';
// Import Hindi translations
import hiAccount from './locales/hi/account.json';
import hiAuth from './locales/hi/auth.json';
import hiBrowse from './locales/hi/browse.json';
import hiCommon from './locales/hi/common.json';
import hiDashboard from './locales/hi/dashboard.json';
import hiOrganization from './locales/hi/organization.json';
import hiPayments from './locales/hi/payments.json';
import hiReferral from './locales/hi/referral.json';
import hiValidation from './locales/hi/validation.json';
// Import Indonesian translations
import idAccount from './locales/id/account.json';
import idAuth from './locales/id/auth.json';
import idBrowse from './locales/id/browse.json';
import idCommon from './locales/id/common.json';
import idDashboard from './locales/id/dashboard.json';
import idOrganization from './locales/id/organization.json';
import idPayments from './locales/id/payments.json';
import idReferral from './locales/id/referral.json';
import idValidation from './locales/id/validation.json';
// Import Italian translations
import itAccount from './locales/it/account.json';
import itAuth from './locales/it/auth.json';
import itBrowse from './locales/it/browse.json';
import itCommon from './locales/it/common.json';
import itDashboard from './locales/it/dashboard.json';
import itOrganization from './locales/it/organization.json';
import itPayments from './locales/it/payments.json';
import itReferral from './locales/it/referral.json';
import itValidation from './locales/it/validation.json';
// Import Japanese translations
import jaAccount from './locales/ja/account.json';
import jaAuth from './locales/ja/auth.json';
import jaBrowse from './locales/ja/browse.json';
import jaCommon from './locales/ja/common.json';
import jaDashboard from './locales/ja/dashboard.json';
import jaOrganization from './locales/ja/organization.json';
import jaPayments from './locales/ja/payments.json';
import jaReferral from './locales/ja/referral.json';
import jaValidation from './locales/ja/validation.json';
// Import Korean translations
import koAccount from './locales/ko/account.json';
import koAuth from './locales/ko/auth.json';
import koBrowse from './locales/ko/browse.json';
import koCommon from './locales/ko/common.json';
import koDashboard from './locales/ko/dashboard.json';
import koOrganization from './locales/ko/organization.json';
import koPayments from './locales/ko/payments.json';
import koReferral from './locales/ko/referral.json';
import koValidation from './locales/ko/validation.json';
// Import Malay translations
import msAccount from './locales/ms/account.json';
import msAuth from './locales/ms/auth.json';
import msBrowse from './locales/ms/browse.json';
import msCommon from './locales/ms/common.json';
import msDashboard from './locales/ms/dashboard.json';
import msOrganization from './locales/ms/organization.json';
import msPayments from './locales/ms/payments.json';
import msReferral from './locales/ms/referral.json';
import msValidation from './locales/ms/validation.json';
// Import Dutch translations
import nlAccount from './locales/nl/account.json';
import nlAuth from './locales/nl/auth.json';
import nlBrowse from './locales/nl/browse.json';
import nlCommon from './locales/nl/common.json';
import nlDashboard from './locales/nl/dashboard.json';
import nlOrganization from './locales/nl/organization.json';
import nlPayments from './locales/nl/payments.json';
import nlReferral from './locales/nl/referral.json';
import nlValidation from './locales/nl/validation.json';
import plAccount from './locales/pl/account.json';
import plAuth from './locales/pl/auth.json';
import plBrowse from './locales/pl/browse.json';
import plCommon from './locales/pl/common.json';
import plDashboard from './locales/pl/dashboard.json';
import plOrganization from './locales/pl/organization.json';
import plPayments from './locales/pl/payments.json';
import plReferral from './locales/pl/referral.json';
import plValidation from './locales/pl/validation.json';
// Import Portuguese translations
import ptAccount from './locales/pt/account.json';
import ptAuth from './locales/pt/auth.json';
import ptBrowse from './locales/pt/browse.json';
import ptCommon from './locales/pt/common.json';
import ptDashboard from './locales/pt/dashboard.json';
import ptOrganization from './locales/pt/organization.json';
import ptPayments from './locales/pt/payments.json';
import ptReferral from './locales/pt/referral.json';
import ptValidation from './locales/pt/validation.json';
// Import Tagalog translations
import tlAccount from './locales/tl/account.json';
import tlAuth from './locales/tl/auth.json';
import tlBrowse from './locales/tl/browse.json';
import tlCommon from './locales/tl/common.json';
import tlDashboard from './locales/tl/dashboard.json';
import tlOrganization from './locales/tl/organization.json';
import tlPayments from './locales/tl/payments.json';
import tlReferral from './locales/tl/referral.json';
import tlValidation from './locales/tl/validation.json';
// Import Cantonese translations
import yueAccount from './locales/yue/account.json';
import yueAuth from './locales/yue/auth.json';
import yueBrowse from './locales/yue/browse.json';
import yueCommon from './locales/yue/common.json';
import yueDashboard from './locales/yue/dashboard.json';
import yueOrganization from './locales/yue/organization.json';
import yuePayments from './locales/yue/payments.json';
import yueReferral from './locales/yue/referral.json';
import yueValidation from './locales/yue/validation.json';
// Import Mandarin Chinese translations
import zhAccount from './locales/zh/account.json';
import zhAuth from './locales/zh/auth.json';
import zhBrowse from './locales/zh/browse.json';
import zhCommon from './locales/zh/common.json';
import zhDashboard from './locales/zh/dashboard.json';
import zhOrganization from './locales/zh/organization.json';
import zhPayments from './locales/zh/payments.json';
import zhReferral from './locales/zh/referral.json';
import zhValidation from './locales/zh/validation.json';

export const SUPPORTED_LANGUAGES = {
  en: { name: 'English', nativeName: 'English' },
  es: { name: 'Spanish', nativeName: 'Español' },
  fr: { name: 'French', nativeName: 'Français' },
  'fr-CA': { name: 'Canadian French', nativeName: 'Français (Canada)' },
  pl: { name: 'Polish', nativeName: 'Polski' },
  nl: { name: 'Dutch', nativeName: 'Nederlands' },
  pt: { name: 'Portuguese', nativeName: 'Português' },
  zh: { name: 'Mandarin', nativeName: '中文' },
  de: { name: 'German', nativeName: 'Deutsch' },
  yue: { name: 'Cantonese', nativeName: '廣東話' },
  hi: { name: 'Hindi', nativeName: 'हिन्दी' },
  id: { name: 'Indonesian', nativeName: 'Bahasa Indonesia' },
  it: { name: 'Italian', nativeName: 'Italiano' },
  ja: { name: 'Japanese', nativeName: '日本語' },
  ko: { name: 'Korean', nativeName: '한국어' },
  ms: { name: 'Malay', nativeName: 'Bahasa Melayu' },
  tl: { name: 'Tagalog', nativeName: 'Tagalog' },
};

export const DEFAULT_LANGUAGE = 'en';

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    browse: enBrowse,
    payments: enPayments,
    account: enAccount,
    referral: enReferral,
    validation: enValidation,
    organization: enOrganization,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    dashboard: esDashboard,
    browse: esBrowse,
    payments: esPayments,
    account: esAccount,
    referral: esReferral,
    validation: esValidation,
    organization: esOrganization,
  },
  fr: {
    common: frCommon,
    auth: frAuth,
    dashboard: frDashboard,
    browse: frBrowse,
    payments: frPayments,
    account: frAccount,
    referral: frReferral,
    validation: frValidation,
    organization: frOrganization,
  },
  pl: {
    common: plCommon,
    auth: plAuth,
    dashboard: plDashboard,
    browse: plBrowse,
    payments: plPayments,
    account: plAccount,
    referral: plReferral,
    validation: plValidation,
    organization: plOrganization,
  },
  nl: {
    common: nlCommon,
    auth: nlAuth,
    dashboard: nlDashboard,
    browse: nlBrowse,
    payments: nlPayments,
    account: nlAccount,
    referral: nlReferral,
    validation: nlValidation,
    organization: nlOrganization,
  },
  pt: {
    common: ptCommon,
    auth: ptAuth,
    dashboard: ptDashboard,
    browse: ptBrowse,
    payments: ptPayments,
    account: ptAccount,
    referral: ptReferral,
    validation: ptValidation,
    organization: ptOrganization,
  },
  'fr-CA': {
    common: frCACommon,
    auth: frCAAuth,
    dashboard: frCADashboard,
    browse: frCABrowse,
    payments: frCAPayments,
    account: frCAAccount,
    referral: frCAReferral,
    validation: frCAValidation,
    organization: frCAOrganization,
  },
  zh: {
    common: zhCommon,
    auth: zhAuth,
    dashboard: zhDashboard,
    browse: zhBrowse,
    payments: zhPayments,
    account: zhAccount,
    referral: zhReferral,
    validation: zhValidation,
    organization: zhOrganization,
  },
  de: {
    common: deCommon,
    auth: deAuth,
    dashboard: deDashboard,
    browse: deBrowse,
    payments: dePayments,
    account: deAccount,
    referral: deReferral,
    validation: deValidation,
    organization: deOrganization,
  },
  yue: {
    common: yueCommon,
    auth: yueAuth,
    dashboard: yueDashboard,
    browse: yueBrowse,
    payments: yuePayments,
    account: yueAccount,
    referral: yueReferral,
    validation: yueValidation,
    organization: yueOrganization,
  },
  hi: {
    common: hiCommon,
    auth: hiAuth,
    dashboard: hiDashboard,
    browse: hiBrowse,
    payments: hiPayments,
    account: hiAccount,
    referral: hiReferral,
    validation: hiValidation,
    organization: hiOrganization,
  },
  id: {
    common: idCommon,
    auth: idAuth,
    dashboard: idDashboard,
    browse: idBrowse,
    payments: idPayments,
    account: idAccount,
    referral: idReferral,
    validation: idValidation,
    organization: idOrganization,
  },
  it: {
    common: itCommon,
    auth: itAuth,
    dashboard: itDashboard,
    browse: itBrowse,
    payments: itPayments,
    account: itAccount,
    referral: itReferral,
    validation: itValidation,
    organization: itOrganization,
  },
  ja: {
    common: jaCommon,
    auth: jaAuth,
    dashboard: jaDashboard,
    browse: jaBrowse,
    payments: jaPayments,
    account: jaAccount,
    referral: jaReferral,
    validation: jaValidation,
    organization: jaOrganization,
  },
  ko: {
    common: koCommon,
    auth: koAuth,
    dashboard: koDashboard,
    browse: koBrowse,
    payments: koPayments,
    account: koAccount,
    referral: koReferral,
    validation: koValidation,
    organization: koOrganization,
  },
  ms: {
    common: msCommon,
    auth: msAuth,
    dashboard: msDashboard,
    browse: msBrowse,
    payments: msPayments,
    account: msAccount,
    referral: msReferral,
    validation: msValidation,
    organization: msOrganization,
  },
  tl: {
    common: tlCommon,
    auth: tlAuth,
    dashboard: tlDashboard,
    browse: tlBrowse,
    payments: tlPayments,
    account: tlAccount,
    referral: tlReferral,
    validation: tlValidation,
    organization: tlOrganization,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'browse', 'payments', 'account', 'referral', 'validation', 'organization'],

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      // Order of language detection - check cookie first for cross-app sync
      order: ['cookie', 'localStorage', 'navigator', 'htmlTag'],
      // Cache user language preference
      caches: ['cookie', 'localStorage'],
      lookupCookie: 'boon_language',
      lookupLocalStorage: 'boon_language',
    },

    react: {
      useSuspense: false, // Set to true if you want to use Suspense
    },
  });

// Cookie utility functions for cross-subdomain language sharing
const COOKIE_NAME = 'boon_language';
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1 year in seconds

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

const setCookie = (name, value) => {
  // Get the root domain for cookie sharing (e.g., .goboon.co)
  const { hostname } = window.location;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

  // For localhost, don't set domain; for production, set root domain
  const domainPart = isLocalhost ? '' : `; domain=${hostname.split('.').slice(-2).join('.')}`;

  document.cookie = `${name}=${value}; path=/${domainPart}; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;

  // Also save to localStorage for same-origin tab sync
  localStorage.setItem(name, value);
};

// Save locale preference to backend API (using fetch to avoid circular dependency with baseService)
const saveLocaleToAPI = async (languageCode) => {
  try {
    const response = await fetch(`${baseServerUrl}/api/v10/locales`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ locale: languageCode }),
    });

    if (response.ok) {
      Notification.success(i18n.t('language.preferenceSaved'));
    }
  } catch {
    // Silently fail - locale will still be saved in cookie/localStorage
  }
};

// Helper function to change language and optionally save to API
export const changeLanguage = async (languageCode, { saveToAPI = true, reload = true } = {}) => {
  if (SUPPORTED_LANGUAGES[languageCode]) {
    const isLanguageChanging = i18n.language !== languageCode;

    // Save preference to cookie (will be picked up on reload)
    setCookie(COOKIE_NAME, languageCode);

    // Save to API if user is authenticated
    if (saveToAPI) {
      await saveLocaleToAPI(languageCode);
    }

    // Reload page to apply language changes - UI will update after reload
    if (reload && isLanguageChanging) {
      window.location.reload();
      return;
    }

    // Only update UI immediately if not reloading (e.g., on initialization)
    i18n.changeLanguage(languageCode);
    document.documentElement.lang = languageCode;
    // Set text direction for RTL languages
    document.documentElement.dir = ['ar', 'he', 'fa'].includes(languageCode) ? 'rtl' : 'ltr';
  }
};

// Initialize language from user's saved preference (call after login)
export const initializeUserLocale = (userLocale) => {
  if (userLocale && SUPPORTED_LANGUAGES[userLocale]) {
    // Don't save to API or reload since we're loading from API on initial page load
    changeLanguage(userLocale, { saveToAPI: false, reload: false });
  }
};

// Get current language
export const getCurrentLanguage = () => i18n.language || DEFAULT_LANGUAGE;

// Listen for language changes from other tabs/windows (same origin)
window.addEventListener('storage', (event) => {
  if (event.key === COOKIE_NAME && event.newValue) {
    const newLanguage = event.newValue;
    if (SUPPORTED_LANGUAGES[newLanguage] && i18n.language !== newLanguage) {
      i18n.changeLanguage(newLanguage);
      document.documentElement.lang = newLanguage;
      document.documentElement.dir = ['ar', 'he', 'fa'].includes(newLanguage) ? 'rtl' : 'ltr';
    }
  }
});

// Check for language changes from cookies on focus (for cross-origin sync)
window.addEventListener('focus', () => {
  const cookieLanguage = getCookie(COOKIE_NAME);
  if (cookieLanguage && SUPPORTED_LANGUAGES[cookieLanguage] && i18n.language !== cookieLanguage) {
    i18n.changeLanguage(cookieLanguage);
    document.documentElement.lang = cookieLanguage;
    document.documentElement.dir = ['ar', 'he', 'fa'].includes(cookieLanguage) ? 'rtl' : 'ltr';
  }
});

export default i18n;
